import React ,  {useEffect , useRef}  from "react";
import { useSelector  } from 'react-redux';


import {  useUser } from "../../state/reactquery";
import { clicktransferemail } from "../../utils/transfermail";

import './ListMails.scss';
const classNames = require('classnames');
function ListMails({messages}) {
  const {data: user} = useUser(localStorage.getItem('token'))  ;
  const leadactu  = useSelector(state=>state.lead.leadactu);

  const listMailsRef = useRef(null);

  useEffect(()=>{listMailsRef.current?.scrollTo({top: listMailsRef.current.scrollHeight});},[messages]);


  const infotypemessage = (messageRecordType) =>{
    return  (messageRecordType==='Open' || messageRecordType==='Click')?'Lu':messageRecordType==='Delivery'? "Reçu":
            (messageRecordType==='Bounce' || messageRecordType==='SpamComplaint')?"Rejeté":"Envoyé" ;  
  }


  const messageitem = (message) => ( <div key={message.id} className={classNames("message",{ "messageto":message.emailFrom === user?.['postmail']},{"messagefrom":message.emailFrom!==user?.['postmail']})} >
                                        <div className="message_top" >
                                          <div className="message_top_left">{message.emailFrom === user?.['postmail'] ? "Vous" : leadactu.prenom + ' ' + leadactu.nom}</div>
                                          <div className="message_top_right" >
                                            <div> {(new Date(message.created_at)).toLocaleString("fr-FR")} </div>
                                            {message.emailFrom === user?.['postmail'] && <div className={message.RecordType || 'Send'} > {infotypemessage(message.RecordType)} </div>}
                                          </div>
                                        </div>
                                        <div className={classNames("message_content", { "messageto": message.emailFrom === user?.['postmail'] }, { "messagefrom": message.emailFrom !== user?.['postmail'] })}>
                                            <div className="ecranmails_transfer" onClick={()=>clicktransferemail(message)} ></div>
                                          <div className="messagesub"  >{message.Subject} </div>
                                          <div  dangerouslySetInnerHTML={{ __html: message.TextBody?.replaceAll('\n',' <br/>').replaceAll('\\n','<br/>') }}  />
                                          {message?.listattachements?.length > 0 && <div className="message_attachments" >
                                            {message?.listattachements?.map((link, index) => (<a key={index} className="messageattachementlink" href={link} target="blank" >{link?.split('/')?.reverse()[0]}</a>))}
                                          </div>}
                                        </div>
                                      </div> ) ;



  return (<>{messages?.length >0 ? <div ref={listMailsRef} className="listmails">
                  { messages.sort((a,b) => new Date(a.created_at) - new Date(b.created_at)).map(x=> messageitem(x))} 
          </div> :<></>}</>);
}

export default ListMails;